import React, { useEffect, useState, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, Input, FormGroup, Button, Label, Form, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import moment from 'moment';
import './feedback.css';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';
import Table from './common/Table';

const common = require('../utils/Common');

const Feedback = () => {
    const [feedbackData, setFeedbackData] = useState([]);
    const [replyData, setReplyData] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalTwo, setModalTwo] = useState(false);
    const [feedbackReply, setFeedbackReply] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    const [page, setPage] = useState(1);
    
    const navigate = useNavigate();

    const toggle = () => setModal(!modal);
    
    useEffect(() => {
        checkAccess();
    }, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
          return;
        } else {
            setUserRights(rights);
            getFeedback();
        }
    }

    const getFeedback = async (limit = 10, offset = 0, search = {}, loader = true, reset = false, isExport = 0) => {
        if (reset) {
            setPage(1);
            offset = 0;
        } else {
            setPage(offset / limit + 1);
        }
        const parameters = {
            source: 'admin',
            'fromDate': $('#Date-from').val(),
            'toDate': $('#Date-to').val(),
            'limit': limit,
            'offset': offset,
            'export': isExport
        };
        let response = await common.apiRequest('post', '/users/FeedBackDetails', parameters, loader);
        let data = (response.data && response.data.data) ? response.data.data : [];
        if (isExport) {
            return data;
        }
        setFeedbackData(data);
        setTotalRecords(response.data.totalRecords);
    };
    const invoiceId = replyData?.order_item?.order?.invoices?.[0]?.id;

    const reply = async () => {
        const parameters = {
            feedback_id: replyData.id,
            feedback_reply: feedbackReply,
            invoice_id: invoiceId,
            feedback_reply_by: "Admin",
            source: "admin",
        };

        let response = await common.apiRequest('post', '/users/user-feedback', parameters);
        if (response.status === 200) {
            if (response.data.code === "success") {
                alert(response.data.message);
                await getFeedback(10, (page - 1) * 10, {}, true, false);
            } else {
                alert(response.data.error);
            }
        }
        setModal(false);
    };

    const replyFeedback = (data) => {
        setReplyData(data);
        toggle();
    };

    const columns = [
        {
            accessor: "user_reg_id",
            header: "User Id",
            render: row => row.user?.reg_id || "N/A"
        },
        {
            accessor: "invoice_no",
            header: "Invoice No",
            render: row => {
                const invoices = row?.order_item?.order?.invoices || [];
                const sellerInvoice = invoices.find(inv => inv.invoice_type === 'seller_product' && inv.seller_id == row.seller_id);
                return sellerInvoice?.invoice_no || "N/A";
            }
        },
        {
            accessor: "order_id",
            header: "Order Id",
            render: row => row.order_item?.order?.order_id || "N/A"
        },
        {
            accessor: "order_date",
            header: "Order Date",
            render: row => row.order_item?.order?.created_at || "N/A"
        },
        {
            accessor: "user_feedback",
            header: "User Feedback"
        },
        {
            accessor: "created_at",
            header: "Date"
        },
        {
            accessor: "type",
            header: "Category"
        },
        {
            accessor: "vendor_response",
            header: "Response from Vendor",
            render: row => {
                const responses = row.feedback_replys
                    ?.filter(reply => reply.feedback_reply_by === 'seller')
                    .map(reply => reply.feedback_reply) || [];
                return responses.length === 0 ? "No response" : responses.join('\n---\n');
            }
        },
        {
            accessor: "vendor_response_date",
            header: "Date of Response (Vendor)",
            render: row => {
                const dates = row.feedback_replys
                    ?.filter(reply => reply.feedback_reply_by === 'seller')
                    .map(reply => reply.created_at) || [];
                return dates.length === 0 ? "N/A" : dates.join('\n---\n');
            }
        },
        {
            accessor: "admin_response",
            header: "Response from Admin",
            render: row => {
                const responses = row.feedback_replys
                    ?.filter(reply => reply.feedback_reply_by === 'Admin')
                    .map(reply => reply.feedback_reply) || [];
                return responses.length === 0 ? "No response" : responses.join('\n---\n');
            }
        },
        {
            accessor: "admin_response_date",
            header: "Date of Response (Admin)",
            render: row => {
                const dates = row.feedback_replys
                    ?.filter(reply => reply.feedback_reply_by === 'Admin')
                    .map(reply => reply.created_at) || [];
                return dates.length === 0 ? "N/A" : dates.join('\n---\n');
            }
        },
        {
            accessor: "reply",
            header: "Reply",
            render: row => (
                <button className='btn btn-primary btn-sm' onClick={() => replyFeedback(row)}>
                    View
                </button>
            ),
            width: 100
        }
    ];

    const rowData = feedbackData.map((data, index) => {
        const vendorResponses = data.feedback_replys?.filter(reply => reply.feedback_reply_by === 'seller') || [];
        const adminResponses = data.feedback_replys?.filter(reply => reply.feedback_reply_by === 'Admin') || [];
    
        return {
            ...data,
            vendorResponses: vendorResponses.length > 0 
                ? vendorResponses.map(r => r.feedback_reply).join('\n---\n')
                : "No response",
            vendorResponseDates: vendorResponses.length > 0
                ? vendorResponses.map(r => r.created_at).join('\n')
                : "N/A",
            adminResponses: adminResponses.length > 0
                ? adminResponses.map(r => r.feedback_reply).join('\n---\n')
                : "No response",
            adminResponseDates: adminResponses.length > 0
                ? adminResponses.map(r => r.created_at).join('\n')
                : "N/A"
        };
    });
    
    const minifyData = (data) => {
        return data.map((data, index) => ({
            "Reg ID": data.user.reg_id,
            "Invoice no": data.order_item?.order?.invoices?.find(invoice => 
                invoice.invoice_type === 'seller_product' && 
                invoice.seller_id == data.seller_id
            )?.invoice_no,
            "User Feedback": data.user_feedback,
            "Created at": data.created_at,
            "Type": data.type,
            "Vendor Response": rowData[index]?.vendorResponses,
            "Vendor ResponseDate": rowData[index]?.vendorResponseDates,
            "Admin Response": rowData[index]?.adminResponses,
            "Admin Response Date": rowData[index]?.adminResponseDates,
        }));
    }


const handleExportCSV = async () => {
    let data = await getFeedback(10, 0, {}, true, false, 1);
    data = minifyData(data);
    exportToCSV(data, 'Admin Feedback');
}

const handleExportExcel = async () => {
    let data = await getFeedback(10, 0, {}, true, false, 1);
    data = minifyData(data);
    exportToExcel(data, 'Admin Feedback');
}

const handleExportPDF = async () => {
    let data = await getFeedback(10, 0, {}, true, false, 1);
    data = minifyData(data);
    exportToPDF(data, 'Admin Feedback');
}
    return (
        <>
            <div className='feedback-component'>
                <div>
                    <div className='feedback-header col-md-12'>
                        <h2>Users Feedback</h2>
                    </div>
                    <div className="col-md-12">
                        <Form className='row'>
                            <FormGroup className='col-md-4 row'>
                                <Label className="col-md-2 col-form-label" for="Date-from">From:</Label>
                                <input type='date' defaultValue={moment().startOf('month').format('YYYY-MM-DD')} onChange={() => getFeedback()} className="form-control col-md-5" id="Date-from" name="Date-from"></input>
                            </FormGroup>
                            <FormGroup className='col-md-4 row'>
                                <Label className=" col-md-2 col-form-label" for="Date-to">To:</Label>
                                <input type='date' defaultValue={moment().endOf('month').format('YYYY-MM-DD')} onChange={() => getFeedback()} className="form-control col-md-5" id="Date-to" name="Date-to"></input>
                            </FormGroup>
                        </Form>
                    </div>
                    <button className='btn button-product' onClick={handleExportCSV}>Export to CSV</button>
                        <button className='btn button-product' onClick={handleExportExcel}>Export to Excel</button>
                        <button className='btn button-product' onClick={handleExportPDF}>Export to PDF</button>
                    <div className='ag-theme-alpine' style={{ height: 500, width: '100%' }}>
                        <Table
                            columns={columns}
                            data={rowData}
                            totalRecords={totalRecords}
                            pageSize={10}
                            currentPage={page}
                            onPageChange = {(limit, offset, search, reset) =>{
                                getFeedback(limit, offset, search, 0, true, reset);
                            }}
                        />
                    </div>
                </div>
            </div>

            <Modal isOpen={modal} toggle={toggle} size="xl">
                <ModalHeader toggle={toggle}>Feedback reply</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="reply">Reply feedback</Label>
                            <Input
                                type='text'
                                id="feedback_reply"
                                value={feedbackReply}
                                onChange={(e) => setFeedbackReply(e.target.value)}
                            />
                        </FormGroup>
                    </Form>
                    <Button className='submit' onClick={reply}>
                        Submit
                    </Button>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Feedback;

